import type { PriceVenue } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { useIsPriceHistoryV2Enabled } from '@terminal/services/price/price-history-flags';
import { getPreliminaryPrice } from '@terminal/services/price/price-service';

const QUERY_KEY_PRELIMINARY_PRICE = 'QUERY_KEY_PRELIMINARY_PRICE';

export const usePreliminaryPrice = (ticker: string, venue?: PriceVenue) => {
  const isV2 = useIsPriceHistoryV2Enabled();

  return useQuery({
    queryKey: [
      QUERY_KEY_PRELIMINARY_PRICE,
      ticker,
      venue?.exchange,
      venue?.country,
      // The flag selects v1 vs v2 at fetch time; key on it so a mid-session
      // flag change can't reuse a response from the other API version.
      isV2,
    ],
    queryFn: ({ signal }) => getPreliminaryPrice(ticker, venue, signal),
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!ticker,
  });
};
